import request from '@/utils/request'

// 查询会员订阅订单列表
export function listSubscribeOrder(query) {
  return request({
    url: '/member/subscribe/order/list',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询会员订阅订单分页
export function pageSubscribeOrder(query) {
  return request({
    url: '/member/subscribe/order/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询会员订阅订单详细
export function getSubscribeOrder(data) {
  return request({
    url: '/member/subscribe/order/detail',
    method: 'get',
    params: data
  })
}

// 新增会员订阅订单
export function addSubscribeOrder(data) {
  return request({
    url: '/member/subscribe/order/add',
    method: 'post',
    data: data
  })
}

// 修改会员订阅订单
export function updateSubscribeOrder(data) {
  return request({
    url: '/member/subscribe/order/edit',
    method: 'post',
    data: data
  })
}

// 删除会员订阅订单
export function delSubscribeOrder(data) {
  return request({
    url: '/member/subscribe/order/delete',
    method: 'post',
    data: data
  })
}
